<section class="home-page">
  <article class="left-column">
    <img
      [src]="(isDarkMode | async) ? '/assets/logo-title-dark-mode.svg' : '/assets/logo-title-ligth-mode.svg'"
      alt="logo devModeler"
      aria-label="Logo de DevModeler"
      class="light-mode-logo" />
    <h1>{{ title }}</h1>
    <p>
      {{ description }}
    </p>
  </article>
  <img src="/assets/logo-home-page.png" alt="Initiales dev modeler dans une ellipse" class="right-image" />
</section>

<section class="cards">
  @for (card of cards; track $index) {
    <app-card [title]="card.title" [description]="card.description" [button]="card.button"></app-card>
  }
</section>
